// /src/preloadUser.js
 
// fetch initial user info BEFORE authContext initializes state
import axios from "axios";

// English comments only in code blocks
export function preloadUser(rawUser) {
  if (!rawUser || rawUser.isLoggedIn !== true) {
    return null;
  }

  return {
    isLoggedIn: true,
    userId: rawUser.userId ?? null,
    email: rawUser.email ?? null,
    discordName: rawUser.discordName ?? null,
    discordId: rawUser.discordId ?? null,
    hasMfa: rawUser.hasMfa ?? false,
    mfaType: rawUser.mfaType ?? null,
    handles: rawUser.handles ?? null,
    language: rawUser.language ?? null,
    timezone: rawUser.timezone ?? null,
    lastAcceptanceDate: rawUser.lastAcceptanceDate ?? null,
    gcuAccepted: rawUser.gcuAccepted ?? false,
    sessionId: rawUser.sessionId ?? null,
    rankImageUrl: rawUser.rankImageUrl ?? null,
    rankColors: rawUser.rankColors ?? null,
    isAltAccount: Boolean(rawUser.isAltAccount),
  };
}

